import { Injectable, Optional } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import * as actions from './remote-config.actions';
import { ApplicationReady } from '../actions';
import { fetchAndActivate, getAll, RemoteConfig } from '@angular/fire/remote-config';

@Injectable()
export class RemoteConfigEffects {
  remoteConfigUpdates$ = createEffect(() =>
    this.remoteConfig
      ? this.actions$.pipe(
          ofType(ApplicationReady),
          switchMap(() => of(fetchAndActivate(this.remoteConfig))),
          map(() => getAll(this.remoteConfig)),
          map((data) => new actions.SetRemoteConfig(data))
        )
      : of(new actions.RemoteConfigNotAvailable())
  );

  constructor(private actions$: Actions<any>, @Optional() private remoteConfig: RemoteConfig) {}
}
